import classNames from "classnames";
import { useState } from "react";
import { useNavigate } from "react-router";

import { navProducts, navSupport } from "@/data/siteContent";
import { useT } from "@/i18n";
import { pathNames } from "@/router/paths";

import { mobileCardClass } from "../mobileCardClass";
import { MobileNavGroup } from "./MobileNavGroup";
import { MobileNavLink } from "./MobileNavLink";
import { MobileNavRow } from "./MobileNavRow";

export function FooterMobileNav() {
  const lt = useT();
  const navigate = useNavigate();
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const toggle = (key: string) => {
    setOpenKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  return (
    <nav
      className={classNames(mobileCardClass, "mt-6")}
      aria-label={lt("nav.support")}
    >
      {/* 移动端底部导航 */}
      {/* 产品（可展开） */}
      <MobileNavGroup
        title={lt("nav.products")}
        open={openKeys.includes("products")}
        onToggle={() => toggle("products")}
      >
        {navProducts.map((item) => (
          <MobileNavLink
            key={item.path + item.labelKey}
            label={lt(item.labelKey)}
            onClick={() => navigate(item.path)}
          />
        ))}
      </MobileNavGroup>

      {/* 关于（直接跳转） */}
      <MobileNavRow
        title={lt("nav.about")}
        onClick={() => navigate(pathNames.about)}
      />

      {/* 支持（可展开，两列卡片链接） */}
      <MobileNavGroup
        title={lt("nav.support")}
        open={openKeys.includes("support")}
        onToggle={() => toggle("support")}
      >
        {/* 支持链接网格 */}
        <div className="grid grid-cols-2 gap-2 pt-2">
          {navSupport.map((item) => (
            <MobileNavLink
              key={item.path}
              variant="chip"
              label={lt(item.labelKey)}
              onClick={() => navigate(item.path)}
            />
          ))}
        </div>
      </MobileNavGroup>
    </nav>
  );
}
